import React, { useEffect, useState, useContext } from 'react'
import styles from './styles.module.scss'
import { Input, Checkbox, Textarea } from '../../../components/ModalInputs'
import { EventListContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/Button'
import CustomSelect from '../../../components/CustomSelect'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import EventLevels from '../../EventLevels'
import Modal from 'react-responsive-modal'
import ActivityTypes from '../../ActivityTypes'
import EducDirections from '../../EducDirections'
import EventTypes from '../../EventTypes'
import { getRoomsList } from '../../../actions/rooms'
import ModalFooter from './Components/ModalFooter'
import { getLibraryEventRooms } from '../../../actions/library'


const CONTEST_TYPES = [
  'личное',
  'не соревнование',
  'командное (классы)',
  'сборная учебного заведения',
]

export default function Main() {

  const dispatch = useDispatch()

  const { closeModal, event, formik } = useContext(EventListContext)
  console.log('formik::: ', formik);
  console.log('event::: ', event);
  const { newsLevels, eventTypes, educDirections, eventForms, eventRooms } = useSelector(state => state.library)
  const { values, errors, touched, submitCount, setFieldValue, handleSubmit } = formik

  const mainValues = values.main

  const [selectMO, setSelectMO] = useState(null)
  const [modalValue, setModalValue] = useState(null)

  const handleMainChange = (e) => {
    const { name, value } = e.target
    setFieldValue(`main.${name}`, value)
  }

  const handleSubmitTitle = () => {
    handleSubmit()
  }

  const handleResetForm = () => {
    // setFieldValue('main.title', '')
  }

  useEffect(() => {
    dispatch(getLibraryEventRooms())
  }, [])

  useEffect(() => {
    const { acid, news_level_id, edid, ev_type_id } = modalValue || {};
    acid && setFieldValue('main.acid', acid);
    news_level_id && setFieldValue('main.news_level_id', news_level_id);
    edid && setFieldValue('main.edid', edid);
    ev_type_id && setFieldValue('main.ev_type_id', ev_type_id);
  }, [modalValue]);

  const openSubModalComp = (mode) => {
    if (mode === 1) { setSelectMO(<EventLevels closeSubModal={closeSubModal} data='eventList' setModalValue={setModalValue} />) }
    if (mode === 2) { setSelectMO(<EducDirections closeSubModal={closeSubModal} data='eventList' setModalValue={setModalValue} />) }
    if (mode === 3) { setSelectMO(<ActivityTypes closeSubModal={closeSubModal} data='eventList' setModalValue={setModalValue} />) }
    if (mode === 4) { setSelectMO(<EventTypes closeSubModal={closeSubModal} data='eventList' setModalValue={setModalValue} />) }
  }
  const closeSubModal = () => {
    setSelectMO(null)
  }

  const error = (fieldName) => (touched?.main?.[fieldName] || submitCount) && errors?.main?.[fieldName]

  const handleSelectChange = (name, value) => {
    setFieldValue(`main.${name}`, value)
  }

  const handleRoomChange = (name, value) => {
    const room = eventRooms?.find((item) => String(item.rid) === String(value))
    setFieldValue('main.rid', value)
    setFieldValue('main.author', room?.name || mainValues?.author || '')
  }

  return (
    <>
      {!!selectMO &&
        <Modal open={selectMO} onClose={closeSubModal} center={true} className={styles.modalWrapper}>
          {selectMO}
        </Modal>
      }
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              error={error('date')}
              required
              type='datetime-local'
              label='Начало'
              name='date'
              value={mainValues?.date || ''}
              onChange={handleMainChange}
            />
            <div className={styles.checkbox}>
              <Checkbox
                label='Входит в план ГУК МО РФ'
                name='planGUK'
                checked={mainValues?.planGUK || false}
                onChange={() => setFieldValue('main.planGUK', !mainValues?.planGUK)}
              />
            </div>
            <Input
              error={error('dend')}
              required
              type='datetime-local'
              label='Окончание'
              name='dend'
              value={mainValues?.dend || ''}
              onChange={handleMainChange}
            />
            <div className={styles.checkbox}>
              <Checkbox
                label='Регулярное'
                name='regular'
                checked={mainValues?.regular || false}
                onChange={() => setFieldValue('main.regular', !mainValues?.regular)}
              />
            </div>
          </div>
          <div className={styles.checkbox}>
            <Input
              error={error('title')}
              required
              label='Название'
              name='title'
              maxLength={120}
              value={mainValues?.title || ''}
              onChange={handleMainChange}
              style={{ width: '500px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <div className={styles.checkbox}>
              <Checkbox
                label='Внутреннее'
                name='inner_event'
                checked={mainValues?.inner_event || false}
                onChange={() => {
                  const next = !mainValues?.inner_event
                  setFieldValue('main.inner_event', next)
                  setFieldValue('main.rid', '')
                  setFieldValue('main.author', '')
                }}
              />
            </div>
            {mainValues?.inner_event ? (
              <CustomSelect
                title='Место проведения'
                required
                error={error('author')}
                valuesName="rid"
                value={mainValues?.rid}
                options={eventRooms && arrayForSelect(eventRooms, 'name', 'rid')}
                setFieldValue={handleRoomChange}
                withoutAll
              />
            ) : (
              <Input
                required
                error={error('author')}
                label='Место проведения'
                name='author'
                value={mainValues?.author || ''}
                onChange={handleMainChange}
                style={{ minWidth: '520px' }}
              />
            )}
          </div>
          <div className={styles.inputsRow}>
            <div className={styles.ModalRow}>
              <div className={styles.select_Modal_Row}>
                <CustomSelect
                  title='Уровень мероприятия'
                  required
                  error={error('news_level_id')}
                  valuesName="news_level_id"
                  value={mainValues?.news_level_id}
                  options={newsLevels && arrayForSelect(newsLevels, 'news_level', 'news_level_id')}
                  setFieldValue={(name, value) => handleSelectChange(name, value)}
                  withoutAll
                />
                <div className={styles.div_dot} onClick={() => openSubModalComp(1)}> + </div>
              </div>
              <div className={styles.select_Modal_Row}>
                <CustomSelect
                  title='Направление воспитательной работы'
                  required
                  error={error('edid')}
                  valuesName="edid"
                  value={mainValues?.edid}
                  options={educDirections && arrayForSelect(educDirections, 'name', 'edid')}
                  setFieldValue={(name, value) => handleSelectChange(name, value)}
                  withoutAll
                />
                <div className={styles.div_dot} onClick={() => openSubModalComp(2)}> + </div>
              </div>
            </div>
            <div className={styles.ModalRow}>
              <div className={styles.select_Modal_Row}>
                <CustomSelect
                  title='Форма мероприятия'
                  required
                  error={error('acid')}
                  valuesName="acid"
                  value={mainValues?.acid}
                  options={eventForms && arrayForSelect(eventForms, 'name', 'acid')}
                  setFieldValue={(name, value) => handleSelectChange(name, value)}
                  withoutAll
                />
                <div className={styles.div_dot} onClick={() => openSubModalComp(3)}> + </div>
              </div>
              <div className={styles.select_Modal_Row}>
                <CustomSelect
                  title='Тип события'
                  required
                  error={error('ev_type_id')}
                  valuesName="ev_type_id"
                  value={mainValues?.ev_type_id}
                  options={eventTypes && arrayForSelect(eventTypes, 'ev_type', 'ev_type_id')}
                  setFieldValue={(name, value) => handleSelectChange(name, value)}
                  withoutAll
                />
                <div className={styles.div_dot} onClick={() => openSubModalComp(4)}> + </div>
              </div>
            </div>
          </div>
          <CustomSelect
            title='Вид соревнования'
            valuesName="cont_type"
            value={mainValues?.cont_type}
            options={CONTEST_TYPES.map(item => ({ name: item, value: item }))}
            setFieldValue={(name, value) => handleSelectChange(name, value)}
            withoutAll
          />

          <br />
          <Button onClick={handleResetForm}>Очистить формат</Button>
          <Textarea
            className={styles.textarea}
            name={"text"} label="Текст"
            value={mainValues?.text || ''}
            onChange={handleMainChange} />
        </div>
      </div>

      <ModalFooter
        event={event}
        onSave={handleSubmitTitle}
        onClose={closeModal}
        showValue={mainValues?.show}
        onShowChange={() => setFieldValue('main.show', !mainValues?.show)}
        showCheckbox={true}
      />
    </>

  )
}
